import client from '@/api_client/client';
import { ICalendarEvent } from '@/types/calendar-event/ICalendarEvent';
import { IListCalendarEventsResponse } from '@/types/calendar-event/IListCalendarEventsResponse';
import copy from '@/utils/copy';

type ICreateArgs = Partial<ICalendarEvent> & {
	id: string;
	calendarId: string;
};

function create(args: ICreateArgs) {
	const argsCopy = copy(args);

	if (!argsCopy.interval?.inclusiveStart?.dateTime || !argsCopy.interval.exclusiveEnd?.dateTime) {
		delete argsCopy.interval;
	}

	return client.put(`/calendar-events/${argsCopy.id}`, { ...argsCopy }).then((res) => res.data);
}

interface IListArgs {
	/**
	 * An array of ids to get the events from.
	 */
	calendarIds?: string;
	timeMin: string;
	timeMax: string;
	includeEventsWithoutInterval: boolean;
}

function list(args: IListArgs) {
	return client.get<IListCalendarEventsResponse>('/calendar-events', { params: args }).then((res) => res.data);
}

interface IGetArgs {
	id: string;
}

function get(args: IGetArgs) {
	return client.get<ICalendarEvent>(`/calendar-events/${args.id}`).then((res) => res.data);
}

interface IRemoveArgs {
	id: string;
}
function remove(args: IRemoveArgs) {
	return client.delete(`/calendar-events/${args.id}`).then((res) => res.data);
}

export default { get, list, create, remove };
